import { useMemo } from 'react';

import {
  URLSearchParamsInit,
  useSearchParams,
  SetURLSearchParams,
} from 'react-router-dom';

type QueryValue = string | string[] | null;

type QueryObject<T extends string = string> = Partial<Record<T, QueryValue>>;

function useQueryParams<T extends string = string>(
  filters?: URLSearchParamsInit,
): [QueryObject<T>, SetURLSearchParams, string] {
  const [query, setQuery] = useSearchParams(filters);

  const queryObject = useMemo(() => {
    const obj: QueryObject<T> = {};

    for (const key of query.keys()) {
      const values = query.getAll(key);

      if (values.length > 1) {
        obj[key as T] = values;
      } else {
        obj[key as T] = values[0] ?? null;
      }
    }

    return obj;
  }, [query]);

  return [queryObject, setQuery, query.toString()];
}

export default useQueryParams;
